import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import WarehouseCommonApi from '../../../../../API/warehouse/common-api';
import default_pictute from '../../../../../assets/media/icons/products.png';
import { Column, ImagesViewer, Row, WhiteBlock } from '../../../../../components/Basic/Blocks';
import { Input, InputLabel } from '../../../../../components/Basic/Inputs';
import { Text } from '../../../../../components/Basic/WrapsStyle';
import BarcodesBlock from '../../../../../components/Common/Input/Barcodes';
import WarehouseAddressInput from '../../../../../components/Warehouse/WarehouseAddressInput';
import { IP } from '../../../../../constans';
import { formFullDate } from '../../../../../utils';
import InventoryStepper from '../../ProductsTableLine/InventoryStepperInput/Stepper';
import ReserveStepper from '../../ProductsTableLine/ReserveStepperInput/Stepper';
import WarehouseStepper from '../../ProductsTableLine/WarehouseStepperInput/Stepper';
import styles from './styles.module.scss';
import ProviderList from '../../../../../components/Common/Input/ProviderList';

const InfoBlock = ({ isInventory = false, p, skladData = {}, save = (_) => _ }) => {
  const [product, setProduct] = useState(p);

  const skladName = useSelector(store => store.ui.skladName.short_name);

  const user = useSelector((store) => store.user);

  const onChange = async (field, value, action = null) => {
    await WarehouseCommonApi.changeProduct({ data: { warehouseId: product.id, field, value, action, isInventory: false, skladName } }).then((p) => {
      setProduct(p.warehouseProduct);
      save(p.warehouseProduct);
    });
  };

  useEffect(() => {
    setProduct(p);
  }, [p]);

  const reserved = skladData.shipment_reserved + skladData.hand_reserved;
  return (
    <WhiteBlock style={{ width: '600px', minWidth: '600px', paddingBottom: '50px' }} title="Данные о товаре">
      <>
        <ImagesViewer images={[product.image || default_pictute]} className={styles.picture} small={false} />
        <Row>
          <InputLabel style={{ marginRight: '10px' }}>Артикул:</InputLabel>{' '}
          <Text fontWeight={600} style={{ marginRight: '20px' }}>
            {product.id}
          </Text>
          <InputLabel style={{ margin: ' 0 10px' }}>Дата создания:</InputLabel>{' '}
          <Text fontWeight={600}>{formFullDate(product.created_at)}</Text>
        </Row>

        <Row>
          {/*
          <InputLabel style={{ marginRight: '10px' }}>Источник:</InputLabel> <Text>{product.source}</Text>
*/}
        </Row>

        <Input label="Название товара" value={product.name} onChange={(v) => onChange('name', v)} />
        <Row>
          <Input
            label="Бренд"
            value={product.brand}
            style={{ marginRight: '25px', width: '200px' }}
            onBlur={(v) => onChange('brand', v)}
          />
          <Column style={{ marginTop: '14px' }}>
            <InputLabel>Штрихкод</InputLabel>
            <BarcodesBlock
              barcodes={product.barcodes}
              onAdd={(b) => onChange('barcode', b, 'add')}
              onRemove={(b) => onChange('barcode', b, 'pull')}
            />
          </Column>
        </Row>
        <Input label="Ссылка на картинку" value={product.image} onChange={(v) => onChange('image', v)} />

        <Row>
          <Column className={styles.provider} style={{ marginRight: '25px' }}>
            <InputLabel>Поставщик</InputLabel>
            <ProviderList selectProviderId={product.provider_id} disabled={true} />
          </Column>
          <Input
            label="Артикул поставщика"
            value={product.provider_artnumber}
            style={{ marginRight: '25px' }}
            readOnly
          />
          {(user.role === 'owner' || user.role === 'admin') && (
            <Input label="Цена закупки, руб" value={product.purchase} onChange={(v) => onChange('purchase', v)} />
          )}
        </Row>
        <Row style={{ alignItems: 'flex-end' }}>
          <Input
            label="Остаток на складе"
            value={skladData.stock}
            readOnly
            width={'120px'}
            style={{ marginRight: '20px', width: '120px' }}
          />
          <WarehouseStepper item={product} save={save} skladName={skladName} />
          <Input
            label="Дата обновления остатка"
            value={formFullDate(skladData.date_stock_updated)}
            width={'100%'}
            style={{ marginLeft: '25px' }}
          />
        </Row>
        <Row style={{ alignItems: 'flex-end' }}>
          <Input
            label="Резерв"
            value={reserved}
            readOnly
            width={'120px'}
            style={{ marginRight: '20px', width: '120px' }}
          />
          <ReserveStepper item={product} save={save} skladName={skladName} />
          <div style={{ marginLeft: '25px' }}>
            <WarehouseAddressInput
              label="Адрес на складе"
              warehouseId={product.id}
              address={skladData.address}
              skladName={skladName}
              width={'100%'}
              onChange={(p) => save(p)}
            />
          </div>
        </Row>

        {isInventory && (
          <Row style={{ alignItems: 'flex-end' }}>
            <Input
              label="Инвентаризация"
              value={product.inventory_remains}
              readOnly
              width={'120px'}
              style={{ marginRight: '20px', width: '120px' }}
            />
            <InventoryStepper item={product} save={save} />
            <div style={{ marginLeft: '25px' }}>
              <Select
                label={'Закупочное ИП'}
                select={product.ip}
                onSelect={(ip) => onChange('ip', ip)}
                width={'200px'}
                list={[IP.ARTEM, IP.NIKOLAY, IP.ALENA, IP.SVETANA, IP.IRA, IP.TARAS, IP.DIANA, 'Без ИП']}
              />
            </div>
          </Row>
        )}
      </>
    </WhiteBlock>
  );
};

export default InfoBlock;
